module.exports = __webpack_public_path__ + "static/uppsalauniversitet-18d4b4eac39e163c218dd26f2e4f5268.png";